@let notificationItem = notification();

<flx-notification-content
  [notification]="notificationItem"
  (actionClicked)="actionClicked.emit()"
>
  <div
    class="flex items-center gap-2"
    notificationTitle
  >
    <div
      [pTooltip]="notificationItem.title"
      [showDelay]="TOOLTIP_DEFAULT_DELAY"
      [showOnEllipsis]="true"
      class="flex-1 truncate text-sm/[22px] font-semibold text-neutral-900"
      data-testid="notification-title"
      tooltipPosition="top"
      tooltipStyleClass="text-xs"
      tooltipZIndex="2004"
    >
      {{ notificationItem.title }}
    </div>

    <div class="flex shrink-0 items-center gap-2.5">
      @if (!notificationItem.markedRead) {
        <button
          [showDelay]="TOOLTIP_DEFAULT_DELAY"
          (click)="markAsRead.emit()"
          class="size-4 rounded border-0 bg-neutral-50 p-0 text-neutral-900 opacity-0 hover:bg-neutral-100 focus-visible:opacity-100 group-hover:opacity-100"
          flxButton
          icon="center"
          variant="text"
          type="button"
          data-testid="notification-mark-as-read-button"
          tooltipPosition="top"
          tooltipStyleClass="text-xs"
          tooltipZIndex="2004"
          pTooltip="Mark as read"
        >
          <i
            class="ph ph-check text-base/4"
            flxIcon
          ></i>
        </button>
      }

      <!-- Fixed width so the mark-as-read button lands at the same x on every row: `age()` is 2-3
      characters and a natural-width span would shift the button per row. -->
      <span
        class="w-7 text-right text-xs/[18px] text-neutral-500"
        data-testid="notification-age"
      >
        {{ age() }}
      </span>
    </div>
  </div>
</flx-notification-content>
